import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cross from "../../assets/images/icon/cross.svg";
import { faImages, faLock, faUpload } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { uploadUserDocuments } from "helpers/backend_helper";
import { at, isEmpty } from "lodash";
import { bytesToMB } from "helpers/common";
import edit_icon from "../../assets/images/icon/edit.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { checkPermissionStatus } from "helpers/utils";

const DegreesCertificates = props => {
  const { t } = useTranslation();
  const [degreeList, setDegreeList] = useState([
    {
      id: 1,
      degreeName: "",
      degreeBranch: "",
      yearStart: "",
      yearEnd: "",
      percentage: "",
      university: "",
    },
  ]);
  const [attachments, setAttachments] = useState(new Map().set(1, ""));
  const [errors, setErrors] = useState([{ id: 1 }]);
  const [loading, setLoading] = useState(false);
  const [viewType, setViewType] = useState("view");
  const candidateDetails = props?.data?.length
    ? props?.data?.map(el => {
        return JSON.parse(el?.fields);
      })
    : [];

  const imageTypeAllowed = [
    "application/doc",
    "application/docx",
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const handleFileUpload = async (e, index) => {
    let allErrors = JSON.parse(JSON.stringify(errors));
    let objIndex = allErrors?.findIndex(el => el?.id === index);
    allErrors[objIndex].attachmentFile = "";
    setErrors(allErrors);
    if (e?.target?.files?.length > 0) {
      let maxSize = 25;
      let isError = false;
      if (e?.target?.files?.length > 1) {
        toast.error(
          t(`Degrees & Certificates.Cannot Select More than one Attachment`)
        );
        return false;
      }
      for (let i = 0; i < e?.target?.files?.length; i++) {
        if (!imageTypeAllowed?.includes(e?.target?.files[i]?.type)) {
          isError = true;
        }
        let megabytes = bytesToMB(e?.target?.files[i].size);
        if (megabytes > maxSize) {
          toast.error(
            t(
              `Degrees & Certificates.Please select attachment of size below 25 MB`
            )
          );
          return false;
        }
        attachments.set(index, e?.target?.files[i]);
      }
      if (isError) {
        toast.error(
          t(
            `Degrees & Certificates.Please upload attachment with the following types`
          )
        );
        setLoading(false);
        return;
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (degreeList?.length === 0) {
      toast.error(t(`Degrees & Certificates.Please Add atleast One Entry`));
      return;
    }
    setLoading(true);
    let error = [];
    let isError = false;

    degreeList?.map((el, index) => {
      let err = { id: el.id };
      if (isEmpty(el?.degreeBranch)) {
        err = {
          ...err,
          degreeBranch: t(`Degrees & Certificates.This Field is Required`),
        };
        isError = true;
      }
      if (isEmpty(el?.degreeName)) {
        err = {
          ...err,
          degreeName: t(`Degrees & Certificates.This Field is Required`),
        };
        isError = true;
      }
      if (!el?.yearStart || el?.yearStart?.length < 4) {
        err = {
          ...err,
          yearStart: t(`Degrees & Certificates.This Field is Required`),
        };
        isError = true;
      }
      if (!el?.yearEnd || el?.yearEnd?.length < 4) {
        err = {
          ...err,
          yearEnd: t(`Degrees & Certificates.This Field is Required`),
        };
        isError = true;
      }
      if (isEmpty(el?.percentage)) {
        err = {
          ...err,
          percentage: t(`Degrees & Certificates.This Field is Required`),
        };
        isError = true;
      }
      if (isEmpty(el?.university)) {
        err = {
          ...err,
          university: t(`Degrees & Certificates.This Field is Required`),
        };
        isError = true;
      }
      if (!attachments.get(el.id)) {
        err = {
          ...err,
          attachments: t(`Degrees & Certificates.This Field is Required`),
        };
        isError = true;
      }
      if (parseInt(el?.yearStart) > parseInt(el?.yearEnd)) {
        err = {
          ...err,
          yearStart: t(
            `Degrees & Certificates.Start year Cannot be greater then End Year`
          ),
        };
        isError = true;
      }
      error.push(err);
      return err;
    });

    if (isError) {
      toast.error(t(`Degrees & Certificates.Please Enter Valid Details`));
      setLoading(false);
      setErrors(error);
      return false;
    }
    let userID = props?.user_id;
    let newAttachments = {};
    for (let [key, value] of attachments) {
      let keyName = `attachment-${key}`;
      newAttachments[keyName] = value;
    }

    let payload = {
      degreeList: JSON.stringify(degreeList),
      type: "degreeDetails",
      new_status: "Degree Details",
      ...newAttachments,
      appl_id: props?.appl_id,
    };

    await uploadUserDocuments(payload, userID)
      .then(res => {
        toast.success(
          t(`Degrees & Certificates.Degree Details Updated Successfully`)
        );
        setLoading(false);
        props?.onSubmit();
        setViewType("view");
      })
      .then(err => {
        if (err?.response?.message) {
          toast.error(JSON.stringify(err?.response?.message));
        }
        setLoading(false);
      });
  };

  const getUniqueId = () => {
    let allIds = degreeList?.map(el => el?.id);
    let randomId = getRandomInteger(20);
    while (allIds?.includes(randomId)) {
      randomId = getRandomInteger(20);
    }
    return randomId;
  };

  const getRandomInteger = maxSize => {
    return Math.floor(Math.random() * maxSize);
  };

  const handleRemove = id => {
    let myDegrees = JSON.parse(JSON.stringify(degreeList));
    myDegrees = myDegrees?.filter(el => el.id !== id);
    setDegreeList(myDegrees);
    attachments.delete(id);
  };

  const handleAddMore = e => {
    e.preventDefault();
    if (degreeList?.length > 10) {
      toast.error(
        t(`Degrees & Certificates.Max 10 Degrees/Certificates are allowed`)
      );
      return false;
    }
    let myDegrees = JSON.parse(JSON.stringify(degreeList));
    let uniqueId = getUniqueId();
    myDegrees.push({
      id: uniqueId,
      degreeName: "",
      degreeBranch: "",
      yearStart: "",
      yearEnd: "",
      percentage: "",
      university: "",
    });
    let allErrors = JSON.parse(JSON.stringify(errors));
    allErrors.push({ id: uniqueId });
    setDegreeList(myDegrees);
    setErrors(allErrors);
    attachments.set(myDegrees?.length - 1, "");
  };

  const handleChange = (e, index, type) => {
    let keyElement = e.target?.name || type;
    if (!keyElement) {
      return;
    }
    let keyValue =
      type === "yearStart" || type === "yearEnd"
        ? e?.getFullYear()
        : e.target.value;
    let allDegrees = JSON.parse(JSON.stringify(degreeList));
    allDegrees[index][keyElement] = keyValue;
    setDegreeList(allDegrees);
  };

  const handleAttachmentOpen = file => {
    if (file) {
      if (typeof file === "string") {
        window.open(file);
      } else {
        window.open(URL.createObjectURL(file));
      }
    }
  };

  const handleReset = () => {
    if (props?.data?.length) {
      let myData = props?.data || [];
      attachments.clear();
      let myDegrees = myData?.map(el => {
        let fields = JSON.parse(el?.fields);
        attachments.set(fields?.id, el?.files);
        return fields;
      });
      setDegreeList(myDegrees);
    }
  };

  useEffect(() => {
    if (props?.data?.length) {
      let myData = props?.data || [];
      attachments.clear();
      let myDegrees = myData?.map(el => {
        let fields = JSON.parse(el?.fields);
        attachments.set(fields?.id, el?.files);
        return fields;
      });
      setDegreeList(myDegrees);
    }
  }, [props?.data]);

  return (
    <>
      {/* <div className="modal-header d-flex justify-content-between align-items-center mt-3">
        <h4 className="m-0">Upload Degrees & Certificates Details</h4>
      </div> */}
      <div className="d-flex justify-content-between align-items-center modal-subheading mb-2 pt-2">
        <h4 className="d-flex gap-2 align-items-center">
          {t(`Degrees & Certificates.Degrees & Certificates`)}
        </h4>
        <div>
          {viewType === "view" ? (
            <Link
              className="text-success blue-icon blue-color4"
              to={`#`}
              onClick={() => setViewType("edit")}
              title={t(`Degrees & Certificates.Edit Details`)}
            >
              <img src={edit_icon} alt="delete_icon" />
            </Link>
          ) : (
            <button
              onClick={() => {
                setViewType("view");
                handleReset();
              }}
              className="btn btn-secondary"
            >
              {t(`Degrees & Certificates.Cancel`)}
            </button>
          )}
        </div>
      </div>
      {viewType === "edit" && (
        <div className="filters-cards-cross">
          <div>
            <form
              onSubmit={handleSubmit}
              id="schedulef2f"
              style={{ display: "block" }}
              className="filters-cards-previous"
            >
              <div className="form-group">
                {degreeList &&
                  degreeList?.map((el, index) => {
                    let objIndex = errors?.findIndex(item => item.id === el.id);
                    let errorValues = errors[objIndex];
                    return (
                      <div className="row" key={index}>
                        <div className=" voter-upload">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <label className="btn btn-primary upload-button">
                                <FontAwesomeIcon icon={faUpload} />
                                <span className="mx-2">
                                  {t(
                                    `Degrees & Certificates.Upload Degrees & Certificates`
                                  )}
                                </span>
                                <input
                                  type="file"
                                  multiple
                                  accept={imageTypeAllowed.join(",")}
                                  onChange={e => {
                                    handleFileUpload(e, el.id);
                                  }}
                                  style={{ display: "none" }}
                                />
                              </label>
                              {attachments.get(el?.id) && (
                                <FontAwesomeIcon
                                  className="mx-4"
                                  icon={faImages}
                                  style={{ cursor: "pointer" }}
                                  width={"25px"}
                                  height={"25px"}
                                  onClick={() =>
                                    handleAttachmentOpen(
                                      attachments.get(el?.id)
                                    )
                                  }
                                />
                              )}
                            </div>
                            <button
                              className="btn btn-primary text-right btn-remove-padding"
                              onClick={e => {
                                e.preventDefault();
                                handleRemove(el?.id);
                              }}
                            >
                              -
                            </button>
                          </div>
                          <p className="pb-2">
                            {t(
                              `Degrees & Certificates.Supported file types are`
                            )}
                          </p>
                          {errorValues?.attachments && (
                            <p className="text-danger">
                              {errorValues?.attachments}
                            </p>
                          )}
                        </div>
                        <div className="row form-upload-card">
                          <div className="col-lg-4 col-md-6 mb-4">
                            <span className="font-size-14">
                              {t(`Degrees & Certificates.Degree`)}
                            </span>
                            <div className="mt-2">
                              <input
                                for="degreeName"
                                name="degreeName"
                                type="text"
                                className="form-control"
                                placeholder={t(`Degrees & Certificates.Degree`)}
                                value={el?.degreeName}
                                onChange={e => handleChange(e, index)}
                                title={`${t(`Degrees & Certificates.Degree`)}`}
                              />
                            </div>
                            {errorValues?.degreeName && (
                              <p className="text-danger">
                                {errorValues?.degreeName}
                              </p>
                            )}
                          </div>
                          <div className="col-lg-4 col-md-6 mb-4">
                            <span className="font-size-14">
                              {t(
                                `Degrees & Certificates.Branch / Specialization`
                              )}
                            </span>
                            <div className="mt-2">
                              <input
                                for="degreeBranch"
                                name="degreeBranch"
                                type="text"
                                className="form-control"
                                placeholder={t(
                                  `Degrees & Certificates.Branch / Specialization`
                                )}
                                value={el?.degreeBranch}
                                onChange={e => handleChange(e, index)}
                                title={`${t(
                                  `Degrees & Certificates.Branch / Specialization`
                                )}`}
                              />
                            </div>
                            {errorValues?.degreeBranch && (
                              <p className="text-danger">
                                {errorValues?.degreeBranch}
                              </p>
                            )}
                          </div>

                          <div className="col-lg-4 col-md-6 mb-4">
                            <span className="font-size-14">
                              {t(`Degrees & Certificates.Year of Joining`)}
                            </span>
                            <div className="mt-2">
                              <DatePicker
                                selected={
                                  el?.yearStart
                                    ? new Date().setFullYear(el?.yearStart)
                                    : ""
                                }
                                showYearPicker
                                for="yearStart"
                                name="yearStart"
                                onChange={date => {
                                  handleChange(date, index, "yearStart");
                                }}
                                maxDate={new Date()}
                                className="form-control"
                                dateFormat="yyyy"
                                placeholderText={t(
                                  `Degrees & Certificates.Select Year`
                                )}
                                title={`${t(
                                  `Degrees & Certificates.Year of Joining`
                                )}`}
                              />
                            </div>
                            {errorValues?.yearStart && (
                              <p className="text-danger">
                                {errorValues?.yearStart}
                              </p>
                            )}
                          </div>

                          <div className="col-lg-4 col-md-6 mb-4">
                            <span className="font-size-14">
                              {t(`Degrees & Certificates.Year of Completion`)}
                            </span>
                            <div className="mt-2">
                              <DatePicker
                                selected={
                                  el?.yearEnd
                                    ? new Date().setFullYear(el?.yearEnd)
                                    : ""
                                }
                                showYearPicker
                                name="yearEnd"
                                for="yearEnd"
                                maxDate={new Date()}
                                onChange={date => {
                                  handleChange(date, index, "yearEnd");
                                }}
                                className="form-control"
                                dateFormat="yyyy"
                                placeholderText={t(
                                  `Degrees & Certificates.Select Year`
                                )}
                                title={`${t(
                                  `Degrees & Certificates.Year of Completion`
                                )}`}
                              />
                            </div>
                            {errorValues?.yearEnd && (
                              <p className="text-danger">
                                {errorValues?.yearEnd}
                              </p>
                            )}
                          </div>

                          <div className="col-lg-4 col-md-6 mb-4">
                            <span className="font-size-14">
                              {t(`Degrees & Certificates.Cgpa/Percentage`)}
                            </span>
                            <div className="mt-2">
                              <input
                                for="percentage"
                                name="percentage"
                                type="text"
                                className="form-control"
                                placeholder={t(
                                  `Degrees & Certificates.Cgpa/Percentage`
                                )}
                                value={el?.percentage}
                                onChange={e => handleChange(e, index)}
                                title={`${t(
                                  `Degrees & Certificates.Cgpa/Percentage`
                                )}`}
                              />
                            </div>
                            {errorValues?.percentage && (
                              <p className="text-danger">
                                {errorValues?.percentage}
                              </p>
                            )}
                          </div>

                          <div className="col-lg-4 col-md-6 mb-4">
                            <span className="font-size-14">
                              {t(`Degrees & Certificates.University/College`)}
                            </span>
                            <div className="mt-2">
                              <input
                                for="university"
                                name="university"
                                type="text"
                                className="form-control"
                                placeholder={t(
                                  `Degrees & Certificates.University/College`
                                )}
                                value={el?.university}
                                onChange={e => handleChange(e, index)}
                                title={`${t(
                                  `Degrees & Certificates.University/College`
                                )}`}
                              />
                            </div>
                            {errorValues?.university && (
                              <p className="text-danger">
                                {errorValues?.university}
                              </p>
                            )}
                          </div>
                          <hr className="hr-row" />
                        </div>
                      </div>
                    );
                  })}

                <button
                  className="btn btn-primary btn-add-padding previous-add mb-3"
                  onClick={e => handleAddMore(e)}
                >
                  + {t(`Degrees & Certificates.Add More`)}
                </button>

                <div className="serach-btn">
                  <button className="btn btn-primary search">
                    {t(`Degrees & Certificates.Save`)}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {viewType === "view" && (
        <>
          {candidateDetails?.length > 0 &&
            candidateDetails?.map(el => {
              return (
                <>
                  <div className="personal-card">
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Degrees & Certificates.Degree`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.degreeName}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Degrees & Certificates.Branch / Specialization`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.degreeBranch}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Degrees & Certificates.Year of Joining`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.yearStart}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Degrees & Certificates.Year of Completion`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.yearEnd}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Degrees & Certificates.Cgpa/Percentage`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.percentage}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Degrees & Certificates.University/College`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.university}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Degrees & Certificates.Document`)}
                          {attachments.get(el?.id) &&
                          !checkPermissionStatus(
                            "personal-id-info",
                            "view_unmasked"
                          ) ? (
                            <>
                              {" "}
                              <FontAwesomeIcon
                                icon={faLock}
                                title="You are not authorized to view this document"
                              />
                            </>
                          ) : (
                            <></>
                          )}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          {attachments.get(el?.id) && (
                            <FontAwesomeIcon
                              className="mx-4"
                              icon={faImages}
                              style={{ cursor: "pointer" }}
                              width={"25px"}
                              height={"25px"}
                              onClick={() =>
                                !checkPermissionStatus(
                                  "personal-id-info",
                                  "view_unmasked"
                                )
                                  ? null
                                  : handleAttachmentOpen(
                                      attachments.get(el?.id)
                                    )
                              }
                            />
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="line-braker"></div>
                </>
              );
            })}
          {candidateDetails?.length === 0 && (
            <p className="pdf-details">
              {t(`Degrees & Certificates.No Details Available`)}
            </p>
          )}
        </>
      )}
    </>
  );
};

export default DegreesCertificates;
